import CityPage from "../CityPage";

export default function HickoryHills() {
  return <CityPage slug="hickory-hills" />;
}
